import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
//import { Http, Response, RequestOptions, Headers } from '@angular/http';
import * as firebase from 'firebase/app';
import 'firebase/storage';
import { ActivatedRoute, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthService } from '../../../services/auth/auth.service';
import { WindowService } from '../../../services/window/window.service';
import { FormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormControl, DISABLED } from '@angular/forms/src/model';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable, Subject } from 'rxjs/Rx';
import { User } from '../../datamodel/user';
import { UploadService } from '../../../uploads/shared/upload.service';
import { Upload } from '../../../uploads/shared/upload';
import { ToggleService } from '../../../services/toggle/toggle.service';
import { StateService } from '../../../services/state/state.service';
import { Institution } from '../../../modules/datamodel/institution';
import { Provider } from '../../../modules/datamodel/provider';
import { Ng4LoadingSpinnerModule, Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
interface Invitation {
    type: any;
}
function mapSnapshot(changes: any) {
    return changes.map(a => {
        const data = a.payload.doc.data() as User;
        const id = a.payload.doc.id;
        return { id, ...data };
    });
}
@Component({
    selector: 'form-validation',
    templateUrl: './add-doctor.component.html',
    styleUrls: ['./add-doctor.component.scss'],
    providers: [WindowService]
})
export class AddDoctorComponent implements OnInit, OnDestroy {
    title = 'Add Doctor';
    addDoctorForm: FormGroup;
    tab = 1;
    setTab(newTab) {
        this.tab = newTab;
    };
    isSet = function (tabNum) {
        return this.tab === tabNum;
    };
    objDoctor;
    selectedFiles: FileList;
    currentUpload: Upload;
    private basePath: string = '/doctors';
    uploads: Observable<Upload[]>;
    public lastError: string = null;
    public lastErrorPhone: string = null;
    private imageFileURL = "";
    imgURL = "../../assets/img/no-image.png";

    activeId:string;
    public user: User;
    public selectedInstitution: object;
    public userProfile: object;
    public providerProfile: object;

    private userRef: AngularFirestoreCollection<User>;
    obsUser: Observable<any>;

    private instituteRef: AngularFirestoreCollection<Institution>;
    obsInstitute: Observable<any>;

    private providerRef: AngularFirestoreCollection<any>;
    obsProvider: Observable<any>;

    private inviteRef: AngularFirestoreCollection<any>;
    obsInvite: Observable<any>;


    isFormSubmit:boolean=false;
    constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth, public auth: AuthService, private win: WindowService, private upSvc: UploadService, private fb: FormBuilder, public toggle: ToggleService, private state: StateService, public router: Router, public route: ActivatedRoute, private http: HttpClient, private spinnerService: Ng4LoadingSpinnerService) {
        this.activeId = '';
    }

    generateInviteCode() {
        var text = "";
        var possible = "MDABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789MD";

        for (var i = 0; i < 8; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    sendEmail(email,subject,message) {
        let formModal = {
            from: 'Sandip Kumar <sandip@wegile.com>',
            to: email,
            subject: subject,
            //text: message,
            html: message
        };
        this.http.post("https://us-central1-acct-b9-dev.cloudfunctions.net/sendEmail", formModal, httpOptions)
            .subscribe(x => {
                console.log(x);
                return x;
            });
    }

    getUserProfile(){
        let objUser = firebase.auth().currentUser;
        this.userRef = this.afs.collection('users', ref => ref.where('email', '==', objUser.email));
        this.obsUser = this.userRef.snapshotChanges().map(changes => {
            return changes.map(a => {
                const data = a.payload.doc.data() as User;
                const id = a.payload.doc.id;
                this.userProfile = { id: id, data: data };
                return { "id": id, "data": data };
            });
        });
        this.obsUser.subscribe(docs => {
            this.getInstitute(docs[0].data.adminFor[0].name);
        });
        
    }

    getInstitute(hname){
        //this.instituteRef = this.afs.collection<Institution>(hname);
        this.instituteRef = this.afs.collection('institutions', ref => ref.where('name', '==', hname));
        this.obsInstitute = this.instituteRef.snapshotChanges().map(changes => {
            return changes.map(a => {
                const data = a.payload.doc.data() as Institution;
                const id = a.payload.doc.id;
                this.selectedInstitution = { id: id, data: data };
                return { "id": id, "data": data };
            });
        });
        this.obsInstitute.subscribe(docs => {
            console.log(docs);
        })
    }

    setInstitution(value) {
        console.log(value);
        this
            .state
            .setSelectedInstitutionPath(value);
    }
    
    createDoctorForm() {
        this.addDoctorForm = this.fb.group({
            first_name: ['', Validators.required],
            last_name: ['', Validators.required],
            npi_number: ['', Validators.required],
            phone: ['', [
                Validators.minLength(10),
                Validators.maxLength(10),
                Validators.pattern("[0-9]*")
            ]],
            email: ['', [Validators.required, Validators.email]],
            invite_code: ['', Validators.required],
            doc_type: ['', Validators.required]/*,
            avail_sunday: ['',Validators.required],
            avail_monday: ['',Validators.required],
            avail_tuesday: ['', Validators.required],
            avail_wednesday: ['', Validators.required],
            avail_thursday: ['', Validators.required],
            avail_friday: ['', Validators.required],
            avail_satday: ['', Validators.required],
            accept_swap: ['', Validators.required],
            push_notify: ['', Validators.required],
            email_notify: ['', Validators.required],
            re_copping_schedule: ['', Validators.required]*/
        });
    }

    detectFiles(event) {
        this.selectedFiles = event.target.files;
        this.uploadImage();
    }

    pushUploadImage(upload: Upload) {
        let storageRef = firebase.storage().ref();
        let filename = Math.random().toString(36).split('').filter(function (value, index, self) {
            return self.indexOf(value) === index;
        }).join('').substr(2, 12);
        let uploadTask = storageRef.child(this.basePath + "/" + filename + upload.file.name).put(upload.file);
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
            (snapshot) => {
                // upload in progress
                upload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100
            },
            (error) => {
                // upload failed
                console.log(error)
            },
            () => {
                // upload success
                upload.url = uploadTask.snapshot.downloadURL
                upload.name = upload.file.name
                this.upSvc.saveFileData(upload);
                this.imageFileURL = upload.url;
                this.imgURL = upload.url;
            }
        );
    }

    uploadImage() {
        let file = this.selectedFiles.item(0);
        this.currentUpload = new Upload(file);
        this.pushUploadImage(this.currentUpload);
    }

    deleteImage() {
        let file = this.selectedFiles.item(0);
        this.currentUpload = new Upload(file);
        this.upSvc.deleteUpload(this.currentUpload);
        this.imgURL = "";
    }

    isFieldValid(field){
        return !this.addDoctorForm.get(field).valid && (this.addDoctorForm.get(field).dirty || this.addDoctorForm.get(field).touched);
    }

    submit() {
        this.lastError = null;
        var objDoctor = this.addDoctorForm.value;
        var error = "";
        var self = this;
        if (objDoctor.first_name == "") {
            this.isFieldValid('first_name');
        }
        if (objDoctor.last_name == "") {
            this.isFieldValid('last_name');
        }
        if (objDoctor.npi_number == "") {
            this.isFieldValid('npi_number');
        }
        if (objDoctor.doc_type == "") {
            this.isFieldValid('doc_type');
        }
        if (objDoctor.phone == "") {
            this.isFieldValid('phone');
        }
        if (objDoctor.invite_code == "" && this.activeId == "") {
            this.isFieldValid('invite_code');
        }
        var count = 0;
        if(error == ""){
            var hname = this.selectedInstitution['data']['name'];
            var hid = this.selectedInstitution['id'];
            const hospDoc = this.afs.doc('institutions/' + hid);
            const router = this.router;
            
            if (self.addDoctorForm.value) {
                const afs = self.afs;
                //check for existing provider
                if (self.activeId!==''){
                    self.spinnerService.show();
                    const docId = self.activeId;
                    if(count < 1){
                        self.afs.collection('providers').doc(docId).update({
                            email: objDoctor.email,
                            first_name: objDoctor.first_name,
                            last_name: objDoctor.last_name,
                            photo: self.imageFileURL,
                            phone: objDoctor.phone,
                            npi: objDoctor.npi_number,
                            modified: firebase.firestore.FieldValue.serverTimestamp()
                        }).then(function (res){
                            count++;
                            self.inviteRef = self.afs.collection('provider_invitations', ref => ref.where('provider_id', '==', self.activeId).where('hospital_id', '==', hid));
                            self.inviteRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(idocs => {
                                console.log(idocs);
                                
                                if(idocs.length > 0){
                                    self.afs.collection('provider_invitations').doc(idocs[0].id).update({
                                        email: objDoctor.email,
                                        invite_code: objDoctor.invite_code,
                                        modified: firebase.firestore.FieldValue.serverTimestamp()
                                    }).then(function (r) {
                                        console.log("Invite code updated")
                                    });
                                }else{
                                    afs.collection('provider_invitations').add({
                                        provider_id: self.activeId,
                                        email: objDoctor.email,
                                        hospital_id: hid,
                                        invite_code: objDoctor.invite_code,
                                        created: firebase.firestore.FieldValue.serverTimestamp(),
                                        status: false
                                    }).then(function (r) {
                                        console.log("Invite code added")
                                    });
                                }
                            })


                            //create log
                            let objUser = firebase.auth().currentUser;
                            afs.collection("admin_logs").add({
                                'user_id': objUser.uid,
                                'type': 'update_provider',
                                'data': { provider_id: docId },
                                'created': firebase.firestore.FieldValue.serverTimestamp()
                            });

                            //send email
                            var message = "Dear " + objDoctor.first_name + ",";
                            message += "<p>Your MD Select invitation code is: " + objDoctor.invite_code + "</p>";
                            message += "<p>&nbsp;</p>";
                            message += "<p>Thanks<br>MD Select Team</p>";
                            let formModal = {
                                from: 'MD Select <sandip@wegile.com>',
                                to: objDoctor.email,
                                subject: 'MD Select Invitation',
                                text: message,
                                html: message
                            };
                            self.http.post("https://us-central1-acct-b9-dev.cloudfunctions.net/sendEmail", formModal, httpOptions)
                            .subscribe(x => {
                                console.log(x);
                            });

                            // self.sendEmail(objDoctor.email, 'MD Select Invitation', message);
                            self.spinnerService.hide();
                            router.navigate(['/doctors']);
                            return Promise.resolve();
                        }).catch(function (err){
                            self.spinnerService.hide();
                            console.error("Error writing document: ", err);
                            return Promise.reject(err);
                        });
                    }else{
                        self.spinnerService.hide();
                        router.navigate(['/doctors']);
                    }
                }else{
                    console.log("adding doctor");
                    let obj = {};
                    self.spinnerService.show();
                    obj[hid] = {
                        name: hname,
                        ref: hospDoc.ref,
                        id: hid,
                        invite_code: objDoctor.invite_code,
                        doc_type: objDoctor.doc_type,
                        joined: false
                    };
                    self.afs.collection('providers').add({
                        user_id: "",
                        email: objDoctor.email,
                        first_name: objDoctor.first_name,
                        last_name: objDoctor.last_name,
                        photo: self.imageFileURL,
                        phone: objDoctor.phone,
                        roles: { provider: true },
                        ref: hospDoc.ref,
                        npi: objDoctor.npi_number,
                        doc_type: objDoctor.doc_type,
                        credentialedAt: obj,
                        accept_swap: true,
                        re_copping_schedule: true,
                        created_at: firebase.firestore.FieldValue.serverTimestamp(),
                        preferences: {
                            notifications: {
                                email: true,
                                push: true,
                                sms: true
                            }
                        },
                        availability: {
                            sun: 'full_day',
                            mon: 'full_day',
                            tue: 'full_day',
                            wed: 'full_day',
                            thu: 'full_day',
                            fri: 'full_day',
                            sat: 'full_day'
                        }
                    }).then(function (res) {
                        let providerDocId = res.id;
                        //create invitations
                        afs.collection('provider_invitations').add({
                            provider_id: providerDocId,
                            email: objDoctor.email,
                            hospital_id: hid,
                            invite_code: objDoctor.invite_code,
                            doc_type: objDoctor.doc_type,
                            created: firebase.firestore.FieldValue.serverTimestamp(),
                            status: false
                        }).then(function(r){
                            //send email
                            //send email
                            var message = "Dear " + objDoctor.first_name + ",";
                            message += "<p>Your MD Select invitation code is: " + objDoctor.invite_code + "</p>";
                            message += "<p>&nbsp;</p>";
                            message += "<p>Thanks<br>MD Select Team</p>";
                            let formModal = {
                                from: 'MD Select <sandip@wegile.com>',
                                to: objDoctor.email,
                                subject: 'MD Select Invitation',
                                text: message,
                                html: message
                            };
                            self.http.post("https://us-central1-acct-b9-dev.cloudfunctions.net/sendEmail", formModal, httpOptions)
                                .subscribe(x => {
                                    console.log(x);
                                });


                            let objUser = firebase.auth().currentUser;
                            afs.collection("admin_logs").add({
                                'user_id': objUser.uid,
                                'type': 'update_provider',
                                'data': { provider_id: providerDocId },
                                'created': firebase.firestore.FieldValue.serverTimestamp()
                            });
                            self.spinnerService.hide();
                            router.navigate(['/doctors']);
                            return Promise.resolve();
                        }).catch(function(e){
                            self.spinnerService.hide();
                            console.error("Error writing document: ", e);
                            return Promise.reject(e);
                        });
                    }).catch(function (err) {
                        self.spinnerService.hide();
                        console.error("Error writing document: ", err);
                        return Promise.reject(err);
                    });
                }
            }else{

            }
        }
    }

    getProviderProfile(pid){
        console.log(pid);
        const document: AngularFirestoreDocument<any> = this.afs.doc('providers/' + pid);
        const document$: Observable<any> = document.valueChanges();
        document$.subscribe(data => {
            if (!data) {
                data = {
                    availability: {},
                    preferences: {
                        notifications: {}
                    }                    
                };
            }
            if (data.photo !== "") {
                this.imgURL = data.photo;
                this.imageFileURL = data.photo;
            }
            this.providerProfile = data;
            console.log(this.providerProfile);
            this.addDoctorForm.patchValue({
                first_name: data.first_name,
                last_name: data.last_name,
                npi_number: data.npi,
                phone: data.phone,
                email: data.email,
                doc_type: data.doc_type ? data.doc_type : "",
                accept_swap: data.accept_swap ? "1" : "0",
                re_copping_schedule: data.re_copping_schedule ? "1" : "0",
                avail_sunday: data.availability.sun ? data.availability.sun : "full_day",
                avail_monday: data.availability.sun ? data.availability.mon : "full_day",
                avail_tuesday: data.availability.sun ? data.availability.tue : "full_day",
                avail_wednesday: data.availability.sun ? data.availability.wed : "full_day",
                avail_thursday: data.availability.sun ? data.availability.thu : "full_day",
                avail_friday: data.availability.sun ? data.availability.fri : "full_day",
                avail_satday: data.availability.sun ? data.availability.sat : "full_day",
                push_notify: data.preferences.notifications.push ? "1" : "0",
                email_notify: data.preferences.notifications.email ? "1" : "0"
            });
        });
    }
    
    ngOnInit() {
        this.route.params.subscribe(p => {
            if(p.id){
                this.activeId = p.id;
                this.getProviderProfile(this.activeId);
            }
        });
        this.getUserProfile();
        this.createDoctorForm();
        this.addDoctorForm.patchValue({
            invite_code: this.generateInviteCode(),
            avail_sunday: 'NA',
            avail_monday: 'NA',
            avail_tuesday: 'NA',
            avail_wednesday: 'NA',
            avail_thursday: 'NA',
            avail_friday: 'NA',
            avail_satday: 'NA',
            accept_swap: '1',
            push_notify: '1',
            email_notify: '1',
            re_copping_schedule: '0'
        });
    }

    clickCancel() {
        this.router.navigate(['/doctors']);
    }

    ngOnDestroy() {
        
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/doctors/add-doctor/add-doctor.component.ts